import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { cloneElement, useRef } from 'react';
import { DeliveryTimeWarning } from '~/components/HeaderV3/components/DeliveryTimeWarning';
import { useCartButton } from '~/hooks/useCartButton';

type HeaderCartButton = Omit<
  React.ComponentPropsWithoutRef<'div'>,
  'children'
> & {
  children: React.ReactElement;
};

export const HeaderCartButton = observer<HeaderCartButton>(
  ({ children, className, ...props }) => {
    const buttonRef = useRef<HTMLDivElement>(null);
    const { cartBadgeLabel, handleNavigateCart } = useCartButton();

    return (
      <div {...props} className={cn('relative', className)} ref={buttonRef}>
        {cloneElement(children, {
          onClick: handleNavigateCart,
          className: cn(children.props.className, 'cursor-pointer'),
        })}
        {cartBadgeLabel && (
          <Typography.Text200Semibold
            as="span"
            className="absolute -top-[10px] -right-[14px] size-6 rounded-full bg-navigation-action-brand p-1 text-center text-navigation-text-in-button"
          >
            {cartBadgeLabel}
          </Typography.Text200Semibold>
        )}
        <DeliveryTimeWarning buttonRef={buttonRef} />
      </div>
    );
  },
);
HeaderCartButton.displayName = 'HeaderCartButton';
